import bem from 'utils/bem';

export const block = bem('email-verification-success-modal');
